import { styled } from "styled-components";

export const AppHeaderContainer = styled.div`
width: 100%;
border-bottom: 1px solid black;
height: 60px;
display: flex;
flex-direction: row;
align-items: center;
justify-content: space-between;
background: #0b3157;
padding: 10px;
border-radius: 7px;
`
export const AppHeading = styled.div`
font-size: 18px;
color: #ffffff;
`